import React, { useState } from 'react'
import { useTranslation } from '../i18n/LanguageContext'
import { emptyPlanPayload, browserPlanStorage } from '../lib/planDrafts.js'
import { reusablePlateScenario, writePlateScenario } from '../lib/kentekenDrafts.js'
import { useKentekenDraftRecord, KENTEKEN_ERRORS, downloadPlateScenario } from './KentekenDrafts.jsx'

export function usePlateSpecialistDraft(plate, mileageKm) {
  const record = useKentekenDraftRecord(plate)
  const [payload, setPayload] = useState(() => emptyPlanPayload(null, 'specialist'))
  const [reviewed, setReviewed] = useState(!record.saved?.specialist)
  const needsReview = Boolean(record.saved?.specialist && !reviewed)
  const dirty = !record.saved?.specialist || JSON.stringify(payload) !== JSON.stringify(record.saved.specialist.payload) ||
    record.saved.specialist.mileage !== String(mileageKm)
  return { ...record, payload, setPayload, needsReview, dirty,
    reuse() { setPayload(reusablePlateScenario(record.saved.specialist)); setReviewed(true) },
    startNew() { setPayload(emptyPlanPayload(null, 'specialist')); setReviewed(true) },
    save() {
      if (needsReview) return
      record.accept(writePlateScenario(browserPlanStorage(), { plate, mileage: String(mileageKm), payload,
        expectedRevision: record.saved?.revision ?? null }))
    },
    download() { downloadPlateScenario(record.saved || { plate, mileage: String(mileageKm) }, payload) },
  }
}

export default function PlateSpecialistDraftControls({ draft }) {
  const { t } = useTranslation()
  return <div className="plan-draft-controls plate-specialist-draft">
    {draft.needsReview && <p role="status">
      {t('Fresh plate lookup does not verify your old budget. Reuse clears the exit price, import quote and condition/odometer choices; other allowances and the exit route are retained.')}
      <button type="button" onClick={draft.reuse}>{t('Reuse saved plate assumptions and recheck quotes')}</button>{' '}
      <button type="button" className="plan-secondary" onClick={draft.startNew}>{t('Start a new plate scenario')}</button>
    </p>}
    <div className="plan-draft-actions">
      <button type="button" disabled={draft.needsReview || !draft.dirty} onClick={draft.save}>
        {t(draft.saved?.specialist ? 'Update saved plate scenario' : 'Save plate scenario on this device')}</button>
      <button type="button" className="plan-secondary" onClick={draft.download}>{t('Download inputs, including blanks')}</button>
    </div>
    <small role="status">{t(draft.saved?.specialist && !draft.dirty ? 'Plate scenario saved on this browser. Reopen under Saved; old quotes are never restored automatically.'
      : 'Optional local plate scenario. Other people using this browser can read it. No account sync; save edits explicitly.')}</small>
    {draft.error && <p role="alert">{t(KENTEKEN_ERRORS[draft.error])}</p>}
  </div>
}
